import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '../views/Home.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/diagnostiek',
    name: 'Diagnostiek',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Diagnostiek.vue'),
    meta: {
      title: 'Diagnostiek',
      description: 'Diagnostiek, het vaststellen van het probleem.',
    },
  },
  {
    path: '/behandeling',
    name: 'Behandeling',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Behandeling.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',

    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue'),
  },
  {
    path: '/kwaliteit',
    name: 'Kwaliteit',

    component: () => import(/* webpackChunkName: "kwaliteit" */ '../views/Kwaliteit.vue'),
  },
  {
    path: '/diensten',
    name: 'Diensten',

    component: () => import(/* webpackChunkName: "diensten" */ '../views/Diensten.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',

    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue'),
  },
  {
    path: '/privacy',
    name: 'Privacy',

    component: () => import(/* webpackChunkName: "privacy" */ '../views/Privacy.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
